import React, { Component } from 'react';

class Portfolio extends Component {
    render() {
        return (
            <div className="Portfolio">
                <h1>Portfolio</h1>
            </div>
            );
    }
}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/Components/Portfolio/Portfolio.js